/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Swipe_HintInputs */

const en_us2_wrapped_swipe_hint = /** @type {(inputs: Wrapped_Swipe_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swipe up`)
};

const pt_br2_wrapped_swipe_hint = /** @type {(inputs: Wrapped_Swipe_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslize para cima`)
};

const es_419_wrapped_swipe_hint = /** @type {(inputs: Wrapped_Swipe_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desliza hacia arriba`)
};

const pt_pt2_wrapped_swipe_hint = /** @type {(inputs: Wrapped_Swipe_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desliza para cima`)
};

const fr_fr2_wrapped_swipe_hint = /** @type {(inputs: Wrapped_Swipe_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balaie vers le haut`)
};

const de_de2_wrapped_swipe_hint = /** @type {(inputs: Wrapped_Swipe_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach oben wischen`)
};

const it_it2_wrapped_swipe_hint = /** @type {(inputs: Wrapped_Swipe_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scorri verso l'alto`)
};

/**
* | output |
* | --- |
* | "Swipe up" |
*
* @param {Wrapped_Swipe_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_swipe_hint = /** @type {((inputs?: Wrapped_Swipe_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Swipe_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_swipe_hint(inputs)
	if (locale === "es-419") return es_419_wrapped_swipe_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_swipe_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_swipe_hint(inputs)
	if (locale === "de-DE") return de_de2_wrapped_swipe_hint(inputs)
	if (locale === "it-IT") return it_it2_wrapped_swipe_hint(inputs)
	return en_us2_wrapped_swipe_hint(inputs)
});
export { wrapped_swipe_hint as "wrapped.swipe_hint" }